import tr from "./locales/tr.json";
import en from "./locales/en.json";

export default defineI18nConfig(() => ({
  legacy: false,
  locale: "tr",
  fallbackLocale: "tr",
  messages: {
    tr: tr,
    en: en,
  },
}));
